<template>
  <div>
    <transition name="fade" appear>
      <div v-if="show_message" class="notice">
        <div class="is-flex is-align-items-center is-justify-content-space-between notice_title" :style="{ 'background-image': 'url(' + $settings.get({ path: 'background_theme' }) + ')' }">
          <p class="bold" style="font-size: 24px;">כניסה למערכת</p>
        </div>
        <div style="padding: 10px;">
          <p><b>בוקר טוב {{ $utils.getOwner().name }},</b></p>
          <p>נא לאשר כניסה למערכת:</p>
          <div class="is-flex is-align-items-center">
            <checkbox v-model="is_checked" :checked="is_checked">אין לי תסמינים, נבדקתי הבוקר ואין לי חום</checkbox>
            <div class="horizontal_space"></div>
            <div>
              <a @click="confirm" class="button is-info" :class="{ faded: !is_checked, 'is-loading': is_loading }">אישור</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'notice',
  data () {
    return {
      recruiter: this.$utils.getOwner().name,
      is_loading: false,
      is_checked: false,
      show_message: false,
      time_helper: new TimeHelper(),
      last_login_date: '',
      timer_interval: {}
    }
  },
  beforeDestroy () {
    clearInterval(this.timer_interval)
  },
  created () {
    this.setTimer()
    this.dailyMessageChecker()
  },
  computed: {
    getLastMonthDates () {
      let last_month = this.time_helper.getLastMonth()
      let today = this.time_helper.getCurrentDate()
      return {
        date_from: last_month.toUTCString(),
        date_to: today.toUTCString()
      }
    }
  },
  methods: {
    getCurrentDate () {
      return this.time_helper.getCurrentDate()
    },
    setTimer () {
      this.timer_interval = setInterval(this.dailyMessageChecker, 1000 * 60 * 15)
    },
    dailyMessageChecker () {
      let local_last_daily_message_date = localStorage.getItem('last_daily_message_date')
      if (local_last_daily_message_date == undefined) {
        this.shouldShowDailyMessage().then(() => {
          this.showDailyMessage()
        })
        return
      }
      if (!this.isSameDate(this.getCurrentDate(), new Date(local_last_daily_message_date))) {
        this.shouldShowDailyMessage().then(() => {
          this.showDailyMessage()
        })
      }
    },
    shouldShowDailyMessage () {
      return new Promise((resolve, reject) => {
        this.$network_utils.getStats({ designator: 'recruiter_login', page: 1, per: 1, sort: '-created_at', owner: this.recruiter, ...this.getLastMonthDates }).then(response => {
          let last_login = response[0]
          if (last_login == undefined) {
            resolve()
            return
          }
          let last_login_date = new Date(last_login.created_at)
          this.storeLastDailyMessageDate(last_login_date)
          if (!this.isSameDate(last_login_date, this.getCurrentDate())) {
            resolve()
            return
          }
          this.$network_utils.getStats({
            designator: 'recruiter_logout',
            page: 1,
            per: 1,
            sort: '-created_at',
            owner: this.recruiter,
            date_from: last_login.created_at,
            date_to: this.getCurrentDate().toUTCString()
          }).then(response => {
            if (response[0] == undefined) {
              return
            }
            resolve()
          })
        })
      })
    },
    showDailyMessage () {
      this.show_message = true
    },
    hideDailyMessage () {
      this.is_loading = false
      this.show_message = false
    },
    showConfirmLogoutForm (last_login_stat) {
      this.create({
        designator: 'presence-report-logout-confirmation',
        component_name: 'PresenceReportLogoutConfirmation',
        login_date: last_login_stat.created_at,
        recruiter: this.recruiter,
        modal_title: 'Logout Confirmation',
        show_close_button: false,
        ignore_escape_button: true
      })
    },
    isSameDate (date1, date2) {
      return date1.getDate() == date2.getDate() && date1.getMonth() == date2.getMonth()
    },
    checkLogoutConstitency () {
      let last_login_request = this.$network_utils.getStats({ designator: 'recruiter_login', page: 2, per: 1, sort: '-created_at', owner: this.recruiter, ...this.getLastMonthDates })
      let logouts_request = this.$network_utils.getStats({ designator: 'recruiter_logout', page: 1, per: 5, sort: '-created_at', owner: this.recruiter, ...this.getLastMonthDates })
      this.$network_utils.caller.axios.all([last_login_request, logouts_request]).then(response => {
        let last_login_stat = response[0][0]
        let logouts = response[1]
        this.hideDailyMessage()
        if (this.isLogoutRequired(logouts, last_login_stat)) {
          this.showConfirmLogoutForm(last_login_stat)
        }
      })
    },
    isLogoutRequired (logouts, last_login_stat) {
      if (last_login_stat == undefined) {
        return false
      }
      let last_login_date = new Date(last_login_stat.created_at)
      for (let i = 0; i < logouts.length; i++) {
        let logout_date = new Date(logouts[i].created_at)
        if (this.isSameDate(last_login_date, logout_date) && logout_date.getTime() > last_login_date.getTime()) {
          return false
        }
      }
      return true
    },
    confirm () {
      if (!this.is_checked) {
        this.$utils.emit('show_toast', { text: 'אנא אשר/י את הטופס' })
        return
      }
      this.is_loading = true
      let date = this.getCurrentDate()
      this.storeLastDailyMessageDate(date)
      this.checkLogoutConstitency()
    },
    storeLastDailyMessageDate (date) {
      localStorage.setItem('last_daily_message_date', date)
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    Checkbox
  }
}
</script>
<style scoped>
  .notice{
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    position: fixed;
    direction: rtl;
    z-index: 100000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1000px;
    min-height: 510px;
    background-color: white;
  }
  .notice_title{
    background-size: cover;
    background-position: 30px;
    padding: 10px 20px;
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: var(--color-main);
    width: 100%;
  }
</style>
